// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HYyY","newExpiryDate":"styles_newExpiryDate__1zlsY","footer":"styles_footer__2-FD_"};